<template>
  <page-toolbar :searchable="false" :loading="loading">
    <template #filters>
      <slot></slot>
      <v-col cols="auto">
        <dropdown
          hide-details
          :items="[
            { id: 1, name: $t('one_column') },
            { id: 2, name: $t('two_columns') },
          ]"
          item-value="id"
          v-model="card.type"
          item-text="name"
          :label="$t('type')"
          color="white"
          style="min-width: 180px"
        />
      </v-col>

      <v-col cols="auto">
        <dropdown
          hide-details
          :items="[
            { id: 1, name: 'ID' },
            { id: 2, name: $t('name') },
            { id: 5, name: $t('code') },
            { id: 6, name: $t('group') },
          ]"
          item-value="id"
          multiple
          v-model="card.visible_fields"
          item-text="name"
          :label="$t('show_display')"
          color="white"
          chips
          small-chips
          style="min-width: 250px"
        />
      </v-col>

      <v-col cols="auto" style="max-width: 120px">
        <text-field
          v-model="card.width"
          :label="$t('width')"
          hide-details
          suffix="mm"
          color="white"
        />
      </v-col>

      <v-col cols="auto" style="max-width: 120px">
        <text-field
          v-model="card.height"
          :label="$t('height')"
          hide-details
          suffix="mm"
          color="white"
        />
      </v-col>

      <v-col cols="auto" style="max-width: 140px">
        <text-field
          v-model="card.marginTop"
          :label="$t('margin_top')"
          hide-details
          suffix="px"
          color="white"
          prepend-inner-icon="mdi-refresh"
          @click:prepend-inner="card.marginTop = 'auto'"
        />
      </v-col>

      <v-col cols="auto" style="max-width: 140px">
        <text-field
          v-model="card.fontSize"
          :label="$t('font_size')"
          hide-details
          suffix="px"
          color="white"
        />
      </v-col>

      <print-button class="mt-4" height="40px" @click="print" :loading="loading"></print-button>
    </template>
  </page-toolbar>
</template>

<script>
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  name: "FoodsQrToolbar",
  components: {
    PageToolbar,
  },
  props: {
    foods: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      card: {
        width: "90",
        height: "50",
        marginTop: "25",
        fontSize: "13",
        type: 2,
        visible_fields: [1, 2, 5, 6],
        search: "",
      },
    };
  },
  watch: {
    card: {
      handler(newVal) {
        this.$emit("cardUpdated", { ...newVal });
      },
      deep: true,
    },
  },
  methods: {
    print() {
      this.loading = true;

      let column = this.card.type === 2 ? 2 : 1;
      let html = "<table>";
      let i = 1;

      this.foods.forEach((food, index) => {
        if (index % column === 0) {
          i = 1;
          html += "<tr>";
        }

        const id = food.id;
        const name = this.toLatin(food.name);
        const code = food.code || "";
        const categoryName = food.category?.name ? this.toLatin(food.category.name) : "";

        const style2 =
          index % column === 0
            ? "border-left: 1px solid rgba(0, 0, 0, 0.12); padding-right: 6px"
            : "padding-right: 6px";

        const qrCodeElem = document.getElementById("qrkodstampa" + food.id);

        html += '<td style="' + style2 + '">';
        html += `<div style="padding-left: ${this.card.marginTop}px;width: ${
          this.card.width * 0.4
        }mm; height: ${this.card.height}mm">${qrCodeElem?.innerHTML || ""}</div>`;
        html += "</td>";

        const style =
          index % column === 0
            ? "border-right: 1px solid rgba(0, 0, 0, 0.12);"
            : "border-right: 1px solid rgba(0, 0, 0, 0.12);";

        html += '<td style="' + style + '">';
        html += `<div style="display: flex; flex-direction: column; height: ${
          this.card.height
        }mm; justify-content: center; width: ${this.card.width * 0.6}mm">`;
        html += `<div style="height: ${
          this.card.marginTop === "auto"
            ? this.card.height * 0.4 - 15
            : this.card.height - this.card.marginTop
        }mm; line-height: 1.5">`;

        if (this.card.visible_fields.includes(2)) {
          html += `<div style="font-size: ${this.card.fontSize}px; font-weight: 600">${name}</div>`;
        }
        if (this.card.visible_fields.includes(5) && code) {
          html += `<div style="font-size: ${this.card.fontSize}px; color: #555">
            <strong>${this.$t("code")}: </strong>${code}
          </div>`;
        }
        if (this.card.visible_fields.includes(6) && categoryName) {
          html += `<div style="font-size: ${this.card.fontSize}px; color: #555">
            <strong>${this.$t("group")}: </strong>${categoryName}
          </div>`;
        }
        if (this.card.visible_fields.includes(1)) {
          html += `<div style="font-size: ${this.card.fontSize}px; color: #555">
            <strong>ID: ${id}</strong>
          </div>`;
        }

        html += `</div>`;
        html += `<div style="text-align: end"><span style="margin-right: 10px; color: #aaa">ordera.app</span> <img src="./o.svg" width="30px" style="margin-bottom: -4px;margin-right: ${this.card.marginTop}px"/></div>`;
        html += `</div>`;
        html += "</td>";

        if (i === column) html += "</tr>";
        i++;
      });

      html += "</table>";

      html = [
        "<!DOCTYPE html><html>",
        "<head>",
        "<style>td{border-bottom: 1px solid rgba(0, 0, 0, 0.12);}" +
          "table { page-break-inside:auto }" +
          "tr { page-break-inside:avoid; page-break-after:auto }" +
          "thead { display:table-header-group }" +
          "tfoot { display:table-footer-group }</style>",
        "</head>",
        '<body onload="window.print()" style="font-family: Roboto, sans-serif; font-size: ' +
          (this.card.fontSize - 2) +
          'px!important;">',
        html,
        "</body>",
        "</html>",
      ].join("");

      const win = window.open("", "", "left=0,top=0,toolbar=0,scrollbars=0,status=0");
      win.document.open();
      win.document.write(html);
      win.document.close();

      this.loading = false;
    },
  },
};
</script>
